import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/isAuth";
import searchReducer from "./slices/isSearch";
import qaTypeReducer from "./slices/qAType";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
  //   whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  search: searchReducer,
  qaType: qaTypeReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
